import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useDashboardContext } from '@/common/dashboard/DashboardContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

const CHART_GREEN = '#1B5E20';

export const ChbkFinTrendGraph = ({ totalValues, ctrtTypeIdToCtrtType }) => {
  const { formValues } = useDashboardContext();
  let { dateBasis, monthPeriodId, qtrPeriodId, date, periodicity, distCustIds, ctrtTypeIds, prodIds, agg } = formValues;

  const { totalProdIds, totalDistCustIds } = totalValues;

  const rsrc = useRsrc();

  const [data, setData] = useState([]);

  const chartData = data?.series
    ? {
        ...data,
        series: data.series.map(seriesItem => ({
          ...seriesItem,
          color: CHART_GREEN
        }))
      }
    : data;

  const formatDayCategory = (value) => {
    const raw = String(value ?? '');
    if (raw.length !== 8) {
      return raw;
    }

    const year = raw.substring(0, 4);
    const month = raw.substring(4, 6);
    const day = raw.substring(6, 8);
    return `${month}/${day}/${year}`;
  };

  useEffect(() => {
    const periodId = periodicity === 'MONTH' ? monthPeriodId : periodicity === 'QUARTER' ? qtrPeriodId : null;
    if (!periodId && !date) {
      return;
    }

    let prodIdsNot = true;
    if (totalProdIds.length / 2 < prodIds.length) {
      prodIds = totalProdIds.filter(id => !prodIds.includes(id));
    } else {
      prodIdsNot = false;
    }

    let distCustIdsNot = true;
    if (totalDistCustIds.length / 2 < distCustIds.length) {
      distCustIds = totalDistCustIds.filter(id => !distCustIds.includes(id));
    } else {
      distCustIdsNot = false;
    }

    const reqParam = {
      dateBasis,
      periodId,
      date,
      distCustIds,
      distCustIdsNot,
      ctrtTypes: ctrtTypeIds.map(id => ctrtTypeIdToCtrtType[id]),
      prodIds,
      prodIdsNot,
      agg
    };

    rsrc.data('sc', 'CHBK_FIN_TREND_GRAPH_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });

  }, [dateBasis, monthPeriodId, qtrPeriodId, date, periodicity, distCustIds, ctrtTypeIds, prodIds, agg]);

  const formatAgg = (agg) => {
    if (agg === 'PAID_AMT') {
      return 'Paid Amount';
    } 
    if (agg === 'NET_AMT') {
      return 'Net Amount';
    }
    if (agg === 'PAID_QTY') {
      return 'Paid Quantity';
    }
    return '';
  }

  return (
    <>
        <CartesianChart
          data={chartData}
          yLabel={formatAgg(agg)}
          xLabel={(dateBasis === 'PYMT_DATE' ? 'Payment' : 'Invoice') + (periodicity === 'DAY' ? ' Date' : ' Period')}
          xTickFormatter={periodicity === 'DAY' ? formatDayCategory : undefined}
          legend="top"
        />
    </>

  );
};
